import React from 'react';

const PreviewPDF = ({pdfFile}) => {
    return ( 
        <embed src={pdfFile.dataURL} type="application/pdf"/>
     );
}
 
export default PreviewPDF;